import React, { useEffect } from 'react';
import { useOvermind } from 'src/overmind';

const Deals = () => {
    const { state, actions } = useOvermind()

    useEffect(() => {
        actions.vsoDashboard.setCurrentPage('deals');
    }, []);

    return (
        <div>Deals</div>
    )
}

export default Deals;